Common.Views.Search = Backbone.View.extend({
	tagName: 'div',
	className: 'b-search',
	template: Handlebars.compile($('#block_search').html()),
	resultTemplate: Handlebars.compile($('#block_search_result').html()),
	checkFormTemplate: Handlebars.compile($('#block_check_form').html()),
	partials: {},

	events: {
		'click .js-button--search': 'search',
		'keyup .js-field-input': 'inputKeyup',
		'click .js-check': 'showCheckPopup'
	},
	
	initialize: function () {
		this.render();

		this.modelEventProxy = (Common.createEventProxy(this.model))
			.on('change:isLoading', function () {
				this.partials.$result.toggleClass('b-preloader', this.model.get('isLoading'));

				Common.view.setLBodyWrapperBarWidthOffset();
			}.bind(this))
			.on('change:acts', function () {
				this.renderResult();
			}.bind(this))
			.on('error', function (errors) {
				this.highlightInvalidFields(errors);

				if (errors.messages.length > 1) {
					Common.view.showDetailedNotificator(errors.messages.join('<br>'), null, null, true);
				} else {
					Common.view.showNotificator(errors.messages);
				}
			}.bind(this));
	},

	render: function () {
		this.$el
			.html(this.template())
			.appendTo(Common.view.partials.$content);

		Common.view.setLBodyWrapperBarWidthOffset();

		this.partials.$form = this.$el.find('.js-form');
		this.partials.$result = this.$el.find('.js-result');
		this.partials.$resultList = this.partials.$result.find('.js-result-list');

		this.initUI();
	},

	renderResult: function () {
		this.unbindWaypoint();

		this.partials.$result.removeClass('b-search-result--empty');

		var data = {
				acts: this.model.get('acts'),
				isNextPage: this.model.get('isNextPage'),
				documentsHost: $('meta[name="documents-host"]').attr('content') || 'https://kad.arbitr.ru'
			};

		this.partials.$resultList.html(this.resultTemplate(data));

		Common.view.setLBodyWrapperBarWidthOffset();

		if (data.acts && data.acts.length) {
			this.bindWaypoint();
		} else {
			this.partials.$result.addClass('b-search-result--empty');

			Common.view.showNotificator('По вашему запросу ничего не найдено. Убедитесь, что номер дела указан корректно.');
		}
	},

	clearResult: function () {
		this.unbindWaypoint();

		this.partials.$resultList.empty();
		this.partials.$result.addClass('b-search-result--empty');

		Common.view.setLBodyWrapperBarWidthOffset();
	},

	remove: function () {
		this.modelEventProxy && this.modelEventProxy.off();
		this.$el.remove();
		Common.view.setLBodyWrapperBarWidthOffset();
	},

	initUI: function () {
		this.$el.find('.js-date')
			.datepicker()
			.mask('99.99.9999');
	},

	search: function () {
		var data = Common.toObject(this.partials.$form.serializeArray());

		this.model.set(_.extend({
			page: 1,
			acts: []
		}, data), {
			silent: true
		});

		this.clearResult();

		this.model.search();

		return false;
	},

	inputKeyup: function (e) {
		if (e.which === 13) {
			this.search();
		}
	},

	showCheckPopup: function (e) {
		Common.get('Modal').view.show({
			title: 'Проверка подлинности',
			subTitle: 'Загрузите проверяемый документ в формате doc, docx, rtf, odt или pdf, а также одну или несколько электронных подписей в формате sig, p7s, sgn, pkcs7 или pkcs.',
			message: this.checkFormTemplate({
				caseId: e.currentTarget.getAttribute('data-case_id'),
				actId: e.currentTarget.getAttribute('data-act_id')
			}),
			model: this.model,
			width: 512,
			modifier: 'check_form',
			buttons: [{
				name: 'check_files',
				title: 'Начать проверку'
			}, {
				name: 'cancel',
				title: 'Закрыть окно',
				style: 'inactive'
			}],
			preloader: false,
			afterHideCallback: function () {
				Common.abortRequest('checkFiles');
				Common.view.hidePreloader();
			}
		});
		
		return false;
	},

	highlightInvalidFields: function (errors) {
		Common.view.highlightInvalidateFields(errors, this.partials.$form);
	},

	bindWaypoint: function () {
		var self = this,
			$waypoint = $('.js-waypoint', this.partials.$result);

		if ($waypoint.length) {
			setTimeout(function () {
				self.waypoint = new Waypoint({
					element: $waypoint[0],
					handler: function () {
						this.destroy();

						self.model.set('page', self.model.get('page') + 1);

						self.model.search();
					},
					context: Common.view.partials.$lBody[0],
					offset: '100%'
				});
			}, 0);
		}
	},

	unbindWaypoint: function () {
		this.waypoint && this.waypoint.destroy();
	}
});
